export default {
  GET_CURRENT_USER: 'get_current_user'
}



// WEBPACK FOOTER //
// ./src/action/types.js